/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetBrandNameRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {SetBrandNameResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const setBrandName = (request: SetBrandNameRequest, options?: CashRequestOptions) => post<SetBrandNameRequest, SetBrandNameResponse>("/2.0/cash/set-brand-name", request, {...options, rejectOnError: true })